import React , { useState, useEffect, useMemo, useRef } from "react";
import style from "./LeftPanel.module.css";
import ActionButtons from "../ActionButtons/ActionButtons";
import { useTranslation } from "react-i18next";
import { getAllContacts } from "@src/actions/contacts"
import { getAllAssets } from "@src/actions/assets"
import CustomDropdown from "../../../CustomDropdown/CustomDropdown";
import { formatAgoDate } from "../../../../../../utils/agoDateUtil"
import { ReactComponent as IconSearch } from '../assets/icon-search.svg';
import { ReactComponent as DocumentsDontFound } from '../assets/documentsDontFound.svg';
import { ReactComponent as Folder } from '../assets/folder.svg';
import { ReactComponent as LittleClock } from '../assets/littleClock.svg';
import { ReactComponent as CheckCircleBlack } from '../assets/checkCircleBlack.svg';
import { ReactComponent as Padlock } from '../assets/padlock.svg';
import { ReactComponent as CheckGreen } from '../assets/checkGreen.svg';
import { ReactComponent as Defeated } from '../assets/defeated.svg';
import { ReactComponent as Draft } from '../assets/draft.svg';
import { ReactComponent as Fail } from '../assets/fail.svg';
import { ReactComponent as Canceled } from '../assets/canceled.svg';
import { ReactComponent as Paid } from '../assets/paid.svg';
import { ReactComponent as DocumentIcon } from '../assets/documentIcon.svg';
import { ReactComponent as ImageIcon } from '../assets/imageIcon.svg';
import { ReactComponent as HouseIcon } from '../../../../assets/HouseIcon.svg';
import {ReactComponent as StarExplore} from "../../../../assets/starExplore.svg"
import { ReactComponent as IconDots } from '../assets/icon-dots.svg';
import { ReactComponent as IconImage } from '../assets/icon-avatar.svg';
import { ReactComponent as IconFilter } from '../assets/icon-filter.svg';
import { ReactComponent as IconDocument } from '../assets/icon-doc.svg';
import { ReactComponent as WebIcon } from '../assets/webIcon.svg';
import { ReactComponent as PhoneIcon } from '../assets/phoneIcon.svg';
import { ReactComponent as EmailIcon } from '../assets/emailIcon.svg';
import { ReactComponent as TagIcon } from '../assets/tagIcon.svg';
import { ReactComponent as ImageDefaultAsset } from '../assets/imageDefaultAsset.svg';
import imageDefaultAsset from '../assets/imageDefaultAsset.svg';
import { ReactComponent as ThreeVerticalPoints } from '../assets/threeVerticalPoints.svg';
import { ReactComponent as MapIcon } from '../assets/mapIcon.svg';
import { ReactComponent as FilterIcon1InExplore } from "../../../../assets/filterIcon1InExplore.svg"
import { ReactComponent as ImageDefaultContact } from "../../../../assets/imageDefaultContact.svg"
import { ReactComponent as GreenMailIcon } from "../../../../assets/greenMailIcon.svg";
import { ReactComponent as GreenWebIcon } from "../../../../assets/greenWebIcon.svg";
import { ReactComponent as GreenPhoneIcon } from "../../../../assets/greenPhoneIcon.svg";
import { ReactComponent as GrayTagIcon } from "../../../../assets/tagNewIcon.svg";
import { ReactComponent as IconPending } from '../assets/icon-status-pendent.svg';
import { ReactComponent as NoData } from '../../../../assets/noData.svg';
import imageEmpty from "../../../../assets/ImageEmpty.svg";
import imageDefaultContact from "../../../../assets/imageDefaultContact.svg"
import { useSelector, useDispatch } from "react-redux";
import AmountTransaction from "../../../AmountTransaction/AmountTransaction";
import { useLocation, useNavigate } from "react-router-dom";
import { setAsset, setFatherNewAsset } from "../../../../../../slices/assetsSlices";
import { setTab } from "../../../../../../slices/dashboardSlices";
import { setContact, setFatherNewContact } from "../../../../../../slices/contactsSlices";
import PaginationTables from "../../..//PaginationTables/PaginationTables";
import FiltersDropdownContainer from "../../../FiltersDropdownContainer/FiltersDropdownContainer";
import { getAgents } from "../../../../../../actions/agents.js";
import { clearCurrentChat } from "@src/slices/chatSlices";
import {
  deleteAgent,
  getAgentById,
  getImagesAgents,
  getPublicAgents,
  restartLastMessage,
  searchInWebAction,
} from "../../../../../../actions/chat.js";

import {
  fetchByMenu,
  fetchByChat,
  deleteChat,
  validateTokenGPT,
} from "@src/actions/chat";
import Button from "../../../Button/Button";
import NewTag from "../../../NewTag/NewTag";
import { updateContact } from "../../../../../../actions/contacts.js";
import { updateAsset } from "../../../../../../actions/assets.js";

const NavigationTabs = ({ tabs, activeTab, onTabChange, totalPagination, limit, page, setPage, setLimit,tabEffect }) => {

  return (
    <div className={style.navTabs}>
      <div className={style.buttonsContainer}>
        {tabs.map((tab) => (
          <button
            key={tab.value}
            className={`${style.navTab} ${tabEffect === tab.value ? style.active : ''}`}
            onClick={() => onTabChange(tab.value)}
          >
            {tab.title}
          </button>
        ))}
      </div>
      <div>
        <PaginationTables
          customPaginationNumbers={{ gap: "2px" }}
          customPaginationContainer={{ gap: "2px" }}
          totalData={totalPagination}
          limit={limit}
          page={page}
          setPage={setPage}
          setLimit={setLimit}
          father={"home"}
        />
      </div>
    </div>
  );
};


const SearchBar = ({ searchQuery, onSearchChange, setSelectedOption, selectedOption, options }) => {

  const searchInputRef = useRef(null)
  return (
    <div className={style.searchSection}>
      <div className={style.searchBar}>
        <IconSearch />
        <input ref={searchInputRef}
          type="text"
          className={style.searchInput}
          placeholder="Buscar por nombre, número fiscal, número de factura o referencia"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        <FiltersDropdownContainer customFilterSort={{ whiteSpace: "nowrap" }} customDropdownContainer={{ minWidth: "auto" }}
          setSelectedFilters={setSelectedOption}
          selectedFilters={selectedOption}
          options={options}
          father={"home"}
        />
        <FilterIcon1InExplore style={{ width: "28px", height: "28px" }} />
        <span onClick={() => searchInputRef.current.focus()} className={style.searchIcon} >
          K
        </span>
      </div>
      {/* <button className={style.filterButton}>
                <IconFilter />
            </button> */}
    </div>
  );
};


const IncomeSection = ({ incomes, t , incomeRef}) => {
  // const [t] = useTranslation("Contacts");

  const [selected, setSelected] = useState(1)


  return (
    <div className={style.contentSection} ref={incomeRef} name={'income'}>
      <div id="typeContact" className={`${style.typeContact}`}>
      
                  <div >
                    
                    <button
                      className={`${style.categoryButton} ${selected == 1 && style.selected}`}
                      onClick={() => setSelected(1)}
                      type="button"
                    > {selected == 1 && <CheckCircleBlack/>}
                      {t('all')}
                    </button>
                  </div>
                  <div >
                    
                    <button
                      className={`${style.categoryButton} ${selected == 2 && style.selected}`}
                      onClick={() => setSelected(2)}
                      type="button"
                    > {selected == 2 && <CheckCircleBlack/>}
                      {t('expenseAccounts')}
                    </button>
                  </div>
                  <div >
                    
                    <button
                      className={`${style.categoryButton} ${selected == 3 && style.selected}`}
                      onClick={() => setSelected(3)}
                      type="button"
                    > {selected == 3 && <CheckCircleBlack/>}
                      {t('incomeAccounts')}
                    </button>
                  </div>
      
                </div>

      {/* <div className={style.sectionHeader}>
        <span className={style.sectionTitle}>
          Ingresos y Gastos

          tengo que recuperarlo todo :

        </span>
      </div> */}
      {incomes?.length > 0 ? incomes?.map((income) => (
        <IncomeItem key={income.id} income={income} />
      )) : null}
    </div>
  )
}




const DocumentsSection = ({ documents, t, documentsRef }) => {

  return (
    <div className={style.contentSection} ref={documentsRef} name={'documents'}>
      {/* <div className={style.sectionHeader}>
        <span className={style.sectionTitle}>Documento</span>
        <span className={style.sectionTitle}>Importe</span>
      </div> */}
      <div className={style.documentsRoutes}>
       <HouseIcon/> <span className={style.firstSpan}> {`Home`}</span> <span className={style.firstSpan}> {`>`}</span> <span>{`Q1`}</span>
      </div>
      {documents?.length > 0 ? documents?.map((doc) => (
        <DocumentItem t={t} key={doc.id} document={doc} />
      )) : null }
    </div>
  );
};




const IncomeItem = ({ income }) => {
  const max = 100
  const currentTotal = 30
  const progressPercent = Math.min((currentTotal / max) * 100, 100);
  return (
    <div className={style.incomeItemContainer}>
    <div className={style.incomeItem}>
      <div className={style.left}>
        <span>{income.title}</span>
      </div>
      <div>
        <div className={style.contactAmount} style={{
          flexDirection: income.subCategory == "insurance" && "row",
          gap: income.subCategory == "insurance" && "20px"
          }} >
                            <span>{'0,00€ ~ 0,00€ (0%)'}</span>
                            {income.subCategory == "insurance" ? 
                             <span>{'0,00€ ~ 0,00€ (0%)'}</span>
                            : 
                            <div className={style.progressWrapper}>
                                  {currentTotal > 0 &&
                                    <div className={style.progressBar}>
                                      <div
                                        className={style.progressFill}
                                        style={{ width: `${progressPercent}%` }}
                                      />
                                    </div>
                                  }
                                </div>
                            }
                               
                          </div>
      </div>
      {/* <button>
        <IconDots />
      </button>
      <input type="checkbox" className={style.checkbox} />
      <div className={style.documentIcon}>
        <IconDocument />
      </div>
      <div className={style.documentInfo}>
        <span className={style.documentId}>{income.id}</span>
        <span className={`${style.statusBadge} ${style[`status-${income.statusColor}`]}`}>
          {income.status}
        </span>
        <div className={style.statusDots}>
          {[1, 2, 3, 4, 5].map((item, index) => (
            <div key={index} className={style.statusDot} />
          ))}
        </div>
      </div> */}
    </div>
    </div>
  );
};


const DocumentItem = ({t, key, document }) => {

  const options =[t('Paid'), t('pending'),t('defaulted'),t('due'),t('voided'),t('draft')]

  const customOptions =[
    {key:"paid", name: t('Paid'),label: <span style={{color:"#009F7A", fontWeight: "bold"}}>{t('Paid')}</span>},
    {key:"pending", name: t('pending') ,label: <span style={{color:"#FF9D00", fontWeight: "bold"}}>{t('pending')}</span>},
     {key:"fail", name: t('defaulted') ,label: <span style={{color:"#FF5500", fontWeight: "bold"}}>{t('defaulted')}</span>},
      {key:"defeated", name: t('due') ,label: <span style={{color:"#C5221F", fontWeight: "bold"}}>{t('due')}</span>},
       {key:"canceled", name: t('voided') ,label: <span style={{color:"#8A0300", fontWeight: "bold"}}>{t('voided')}</span>},
        {key:"draft", name: t('draft') ,label: <span style={{color:"#4F5660", fontWeight: "bold"}}>{t('draft')}</span>},
    ]

    const colors = ["#009F7A",
    "#FF9D00",
     "#FF5500",
      "#C5221F",
      "#8A0300",
       "#4F5660",]

      let index = null
        index = customOptions.findIndex(option => option.key == document?.statusColor)

  //  console.log('esto es label',find.label)
  const [optionSelected, setOptionSelected] = useState(document?.statusColor ? customOptions.find(option => option.key == document.statusColor)?.label : "")
  const [customOption, setCustomOption] = useState(document?.statusColor ? customOptions.find(option => option.key == document.statusColor)?.label : "")
  const [selectedColor, setSelectedColor] = useState(colors[index])
  const [currentIcon, setCurrentIcon] = useState(null)
  useEffect(()=> {
    if(optionSelected?.type == "span") return
    else setCurrentIcon(optionSelected)
  },[optionSelected])

  return (
    <div className={style.documentItem}>
      <div className={style.left}>
          {document.type == "folder" ? <Folder/> : document.termination == ".jpg"? <ImageIcon/> : 
         ( document.termination == ".pdf" || document.termination == ".txt") ? <DocumentIcon/> :<></>}
        {document.type == "folder" && <span>{document.title}</span>}
        {document.type != "folder" && <div className={style.textContainer}>
          <span>{document.termination}</span>
          <div>
            <span className={style.firstSpan}>{document.category}</span> <span className={style.secondSpan}>{document.concept}</span>
          </div>
          </div>}
      </div>
      <div className={style.right}>
        <div className={style.firstPart}>
          <div className={style.textContainer}>
            <span>{`${t('modifiedLastTimeFor')} [${document.username}] ${t('does')}`}</span> 
            <span className={style.clear}>{`${t('createdBy')} [${document.username}] ${t('does')} [${document.date}]`}</span>
          </div>
          <div className={ document.separation == "point" && style.pointSeparator} style={{marginLeft:"5px"}}></div>
          <span style={{borderRight: document.type == "folder" && "none", paddingRight: document.type == "folder" &&"10px" }} className={ document.separation == "bar" ? style.barSeparator : document.separation == "point" ? style.pointsSeparator : style.lessSeparator }>{document.capacity}</span>
         {document.type != "folder" &&  <div className={document.separation == "point" && style.pointSeparator} style={{marginRight:"10px"}}></div>}
        </div>
      {document.type != "folder" &&   
      
      <div className={style.secondPart} style={{display: "flex",    alignItems: "center",    gap: "5px", marginRight:"20px"}}>
            {currentIcon == null ? (document.statusColor == "paid"? <Paid/> : document.statusColor == "fail"? <Fail/> :document.statusColor == "canceled"? <Canceled/> :
            document.statusColor == "draft"? <Draft/> :document.statusColor == "defeated"? <Defeated/> :document.statusColor == "pending"? <IconPending/>  :<></>):
            (currentIcon == t('Paid')? <Paid/> : currentIcon == t('defaulted')? <Fail/> :currentIcon == t('voided')? <Canceled/> :
            currentIcon == t('draft')? <Draft/> :currentIcon == t('due')? <Defeated/> :currentIcon == t('pending')? <IconPending/>  :<></>)
            }
          <div>
             <CustomDropdown
                    height="25px"
                    options={options}
                    selectedOption={optionSelected}
                    setSelectedOption={(options) => setOptionSelected(options)}
                    father={"docHome"}
                    // type={'pagination'}
                    generalStyleFilterSort={{background: "transparent",flexDirection: "row-reverse", minWidth: "10px"}}
                    // arrowColorCustom={index != null  && colors[index]}
                    arrowSizeCustom={12}
                    stateStripe={true}
                    generalDropdownHeader={{fontWeight: "bold"}}
                    selectedColor={selectedColor}
                    setSelectedColor={setSelectedColor}
                  />
          </div>
          <CheckGreen/>
          <span></span>
          <Button headerStyle={{padding:"6px 12px"}}> <Padlock  width={9} height={9}/> {t('approve')} </Button>
        </div>
        
        }
        <div className={style.thirdPart} style={{width:"10px"}}>
          <ThreeVerticalPoints/>
        </div>
      </div>
    </div>

   
  );
};


const ContactsSection = ({ contacts,  t, handleSelectCard, result, contactsRef  }) => {

  return (
    <div className={style.contentSection} ref={contactsRef} name={'contacts'}>
      {/* <div className={style.sectionHeader}>
                <span className={style.sectionTitle}>Contacto</span>
                <span className={style.sectionTitle}>Importe</span>
            </div> */}
      {result?.contacts?.length > 0 ? result.contacts.map((contact, index) => (
        <ContactItem key={index} contact={contact} t={t} handleSelectCard={handleSelectCard}
        />
      )) : null}
    </div>
  );
};


const ContactItem = ({ contact, t, handleSelectCard }) => {
  const dispatch = useDispatch()
  const max = 100
  const currentTotal = 30
  const progressPercent = Math.min((currentTotal / max) * 100, 100);
  let { _id, _rev, ...contactData } = contact

  const [showAddTagsContact, setShowAddTagsContact] = useState(false);
  const [selectedTagsContact, setSelectedTagsContact] = useState(contactData?.selectedtags?.length > 0 ? contactData?.selectedtags : []);
  const [tagsContact, setTagsContact] = useState(contactData?.tags?.length > 0 ? contactData?.tags : []);
  const [saveTime, setSaveTime] = useState(false)

  useEffect(() => {
    if (saveTime) {
      dispatch(updateContact({ id: _id, contactData: { ...contactData, selectedtags: [...selectedTagsContact], tags: [...tagsContact] } }))
      setSaveTime(false)
    }
  }, [tagsContact, selectedTagsContact])

  const handleBtnsActions = (type) => {
    if (!contact) return;

    const { companyPhoneNumber, webSite, companyEmail } = contact;

    switch (type) {

      case 'callPhoneNumber':
        if (companyPhoneNumber?.length > 0) {
          const { code, number } = companyPhoneNumber[0];
          window.location.href = `tel:${code}${number}`;
        }
        break;

      case 'website':
        if (webSite) {
          const formattedWebsite = webSite.startsWith('http://') || webSite.startsWith('https://')
            ? webSite
            : `https://${webSite}`;
          window.open(formattedWebsite, '_blank');
        }
        break;

      case 'email':
        if (companyEmail) {
          window.location.href = `mailto:${companyEmail}`;
        }
        break;
      default:
        console.warn('Tipo de acción no reconocido:', type);
    }

  };

  return (
    <div className={style.contactItem}
    //  onClick={() => handleSelectCard(contact, "contact")}
    >
      <div className={style.contactAvatar}>
        <img onError={(e) => {
          e.target.onerror = null;
          e.target.src = imageDefaultContact;
        }}
          src={contact.image || <ImageDefaultContact />}
          alt="Contact"
          width="30"
          height="30"
        />
      </div>
            <div className={style.contactInfo}>
                <div className={style.contactName}>{contact.contactName || t('contactName')}</div>
                <div className={style.contactStats}>
                    {"# Transacciones "}    <div style={{ marginLeft: "5px", marginRight: "5px" }}><AmountTransaction row={contact} /></div> {` Total 0  (${formatAgoDate({ dateString: contact.createdAt, t })}) `}
                </div>
            </div>
            <div className={style.contactRightColumn}>
              <div className={style.firstPart}>
                <div className={style.btnContactInfoContainer}>
                      {/* {contact?.companyPhoneNumber?.length > 0 && ( */}
                            {true && (               
                         <PhoneIcon style={{width:"34px", height:"34px", cursor:"pointer"}}  onClick={(e) => {
                                e.stopPropagation()
                                handleBtnsActions("callPhoneNumber")}} />
                        )}


                         {/* {contact?.companyEmail && ( */}
                            {true && (
                            <EmailIcon style={{width:"34px", height:"34px", cursor:"pointer"}} onClick={(e) => {
                                e.stopPropagation()
                                handleBtnsActions("email")}} />
                        )}


                      {/* {contact?.webSite && ( */}
                        {true && (
                            <WebIcon style={{width:"34px", height:"34px", cursor:"pointer"}}  onClick={(e) => {
                                e.stopPropagation()
                                handleBtnsActions("website")}} />
                        )}


                          <TagIcon style={{width:"34px", height:"34px", cursor:"pointer"}} onClick={(e) => {
                            e.stopPropagation()
                            setShowAddTagsContact(true);
                          }}
                            className={showAddTagsContact && style.activeBtn}
                          />
                      </div>
                          <div className={style.contactAmount} >
                            <span>{'0,00€ ~ 0,00€ (0%)'}</span>
                            
                               <div className={style.progressWrapper}>
                                  {currentTotal > 0 &&
                                    <div className={style.progressBar}>
                                      <div
                                        className={style.progressFill}
                                        style={{ width: `${progressPercent}%` }}
                                      />
                                    </div>
                                  }
                                </div>
                          </div>
                        </div>
                          <div style={{width:"10px"}}>
                            <ThreeVerticalPoints/>
                          </div>
            </div>
             {showAddTagsContact && (
                      <NewTag
                        customoBg={{background:"#00000008"}}
                        setShowNewTagModal={setShowAddTagsContact}
                        setSelectedTags={setSelectedTagsContact}
                        selectedTags={selectedTagsContact}
                        setTags={setTagsContact}
                        tags={tagsContact}
                        setSaveTime={setSaveTime}
                      />
                    )}

    </div>
  );
};




const AssetsSection = ({ assets, t, handleSelectCard, result, assetsRef }) => {
  const dispatch = useDispatch()

  return (
    <div className={style.contentSection} ref={assetsRef} name={'assets'}>
      {/* <div className={style.sectionHeader}>
                <span className={style.sectionTitle}>Activos</span>
                <span className={style.sectionTitle}>Importe</span>
            </div> */}
      {result?.assets?.length > 0 ? result?.assets?.map((asset, index) => (
        <AssetItem key={index} asset={asset} t={t} handleSelectCard={handleSelectCard} />
      )) : null}
    </div>
  );
};


const AssetItem = ({ asset, t, handleSelectCard }) => {

  const dispatch = useDispatch()
  const max = 100
  const currentTotal = 30
  const progressPercent = Math.min((currentTotal / max) * 100, 100);

  let { _id, _rev, ...assetData } = asset

  const [showAddTags, setShowAddTags] = useState(false);
  const [selectedTags, setSelectedTags] = useState(assetData?.selectedtags?.length > 0 ? assetData?.selectedtags : []);
  const [tags, setTags] = useState(assetData?.tags?.length > 0 ? assetData?.tags : []);
  const [saveTime, setSaveTime] = useState(false)

  useEffect(() => {
    if (saveTime) {
      dispatch(updateAsset({ id: _id, assetData: { ...assetData, selectedtags: [...selectedTags], tags: [...tags] } }))
      setSaveTime(false)
    }
  }, [tags, selectedTags])

  const handleBtnsActions = (type) => {
    if (!asset) return;

    const { companyPhoneNumber, webSite, companyEmail } = userData;
    switch (type) {
      case 'clipboard':
        navigator.clipboard.writeText(window.location.href)
          .then(() => console.log('URL copiada al portapapeles'))
          .catch((err) => console.error('Error al copiar al portapapeles:', err));
        setCopyclipboard(true)
        setTimeout(() => {
          setCopyclipboard(false)
        }, 5000);
        break;

      case 'callPhoneNumber':
        if (companyPhoneNumber?.length > 0) {
          const { code, number } = companyPhoneNumber[0];
          window.location.href = `tel:${code}${number}`;
        }
        break;

      case 'website':
        if (webSite) {
          const formattedWebsite = webSite.startsWith('http://') || webSite.startsWith('https://')
            ? webSite
            : `https://${webSite}`;
          window.open(formattedWebsite, '_blank');
        }
        break;

      case 'email':
        if (companyEmail) {
          window.location.href = `mailto:${companyEmail}`;
        }
        break;

      case "inputFileTitle":
        setEditingFileTitle((prev) => !prev)
        break;
      default:
        console.warn('Tipo de acción no reconocido:', type);
    }
  };

  return (
    <div className={style.contactItem}
    //  onClick={() => handleSelectCard(asset, "asset")}
    >
      <div className={style.contactAvatar} style={{ borderRadius: "4px" }}>
        <img style={{ borderRadius: "0px" }} onError={(e) => {
          e.target.onerror = null;
          e.target.src = imageDefaultAsset;
        }}
          src={asset.image || <ImageDefaultAsset />}
          alt="Asset"
        />

      </div>
      <div className={style.contactInfo}>
        <div className={style.contactName}>{asset.name || t('assetTitle')}</div>
        <div className={style.contactStats}>
          {"# Transacciones "}    <div style={{ marginLeft: "5px", marginRight: "5px" }}><AmountTransaction row={asset} /></div> {` Total 0  (${formatAgoDate({ dateString: asset.createdAt, t })}) `}
        </div>
      </div>
   
                <div className={style.contactRightColumn}>
                   <div className={style.firstPart}>
                <div className={style.btnContactInfoContainer}>
                      {/* {contact?.companyPhoneNumber?.length > 0 && ( */}
                            {true && (               
                         <MapIcon style={{width:"34px", height:"34px", cursor:"pointer"}}  onClick={(e) => {
                                e.stopPropagation()
                                handleBtnsActions("map")}} />
                        )}


                      {/* {contact?.webSite && ( */}
                        {true && (
                            <WebIcon style={{width:"34px", height:"34px", cursor:"pointer"}}  onClick={(e) => {
                                e.stopPropagation()
                                handleBtnsActions("website")}} />
                        )}


                          <TagIcon style={{width:"34px", height:"34px", cursor:"pointer"}} onClick={(e) => {
                            e.stopPropagation()
                            setShowAddTags(true);
                          }}
                            // className={showAddTagsContact && style.activeBtn}
                          />
                      </div>
                          <div className={style.contactAmount} >
                            <span>{'0,00€ ~ 0,00€ (0%)'}</span>
                            
                               <div className={style.progressWrapper}>
                                  {currentTotal > 0 &&
                                    <div className={style.progressBar}>
                                      <div
                                        className={style.progressFill}
                                        style={{ width: `${progressPercent}%` }}
                                      />
                                    </div>
                                  }
                                </div>
                          </div>
                    </div>
                          <div style={{width:"10px"}}>
                            <ThreeVerticalPoints/>
                          </div>
            </div>
{showAddTags && (
                      <NewTag
                      customoBg={{background:"#00000008"}}
                        setShowNewTagModal={setShowAddTags}
                        setSelectedTags={setSelectedTags}
                        selectedTags={selectedTags}
                        setTags={setTags}
                        tags={tags}
                        setSaveTime={setSaveTime}
                      />
                    )}

    </div>
  );
};

const TeamSection = ({t, handleSelectCard, teams, teamRef  }) => {

  return (
    <div className={style.contentSection} ref={teamRef} name={'team'}>
      {/* <div className={style.sectionHeader}>
                <span className={style.sectionTitle}>Contacto</span>
                <span className={style.sectionTitle}>Importe</span>
            </div> */}
      {teams?.length > 0 ? teams.map((team, index) => (
        <TeamItem key={index} team={team} t={t} handleSelectCard={handleSelectCard}
        />
      )) : null}
    </div>
  );
};


const TeamItem = ({team, key, t, handleSelectCard }) => {
  const dispatch = useDispatch()
  const nada = [
    {
          id: 'T001',
          status: 'Aprobado',
          my:true
          
        },
        {
          id: 'T002',
          status: 'Aprobado',
          email: 'example@email.com',

        },
         {
          id: 'T003',
          status: 'Aprobado',
          email: 'example@email.com'          
        },
        {
          id: 'T004',
          status: 'pending',
          email: 'example@email.com',
        },
  ]

  return (
    <div className={style.teamItem}
    //  onClick={() => handleSelectCard(contact, "contact")}
    >
      <div className={style.teamLeftColumn}>
      <div className={style.contactAvatar} style={{position:"relative"}}>
        {team.my?
        <div className={style.imageProfileDefault}></div>
        :
        
        <img onError={(e) => {
          e.target.onerror = null;
          e.target.src = imageDefaultContact;
        }}
          src={team.image || <ImageDefaultContact />}
          alt="Contact"
          width="30"
          height="30"
        />
        }
       { team.statusColor &&  <div className={style.statusColor} style={{background:team.statusColor == "green" ? "#10A37F" : team.statusColor == "grey" ? "#c3c3c3" :""}}></div>}
      </div>
            <div className={style.textContainer}>
                <div className={style.topPart}>{team.my ? t('you') : team.status == "pending" ? team.email : t('memberName')}
                 {team.status == "pending" ? <button>{t('pending')}</button> : <StarExplore/>} 

                </div>
                <div className={style.bottomPart}>
                   <span>{t('typeOfAccess')} </span> <div className={style.littlePoint}></div>  <span>{t('role')} </span> {team.status != "pending" && <div className={style.littlePoint}></div>}   { team.my ? <span className={style.clearColor}>{t('memberSince1YearAgo')} </span> : team.status == "pending" ?"" : <span span className={style.clearColor}>{ team.email} </span> }
                </div>
            </div></div>
            <div className={style.teamRightColumn}>
              <div className={style.firstPart}>
                <div className={style.topPart}>
                  <span> {`0,00€ ${t('spent')}`}</span>
                  <span> {`0,00€ ${t('limit')}`}</span>
                </div>
                <div className={style.bottomPart}>
                  <span>{`# ${t('signatures')} `}</span>
                  <span className={style.blackColor}>0</span>
                  <span>{`# ${t('estimatedHours')} `}</span>
                  <span className={style.blackColor}>0</span>
                   <span>{`# ${t('hoursWorked')} `}</span>
                   <span className={style.blackColor}>0</span>
                  <div className={style.pointColor}></div>
                  <span className={style.blackColor}>02:02:02</span>
                  <LittleClock/>
                  <button>{t('vacations')}</button>
                </div>
                        </div>
                          <div style={{width:"10px"}}>
                            <ThreeVerticalPoints/>
                          </div>
            </div>
    </div>
  );
};

const ChatSection = ({ agentsChats, handleSelectCard, t }) => {
  return (
    <div className={style.contentSection}>
      <div className={style.sectionHeader}>
        <span className={style.sectionTitle}>Agentes y Chats</span>
        <span className={style.sectionTitle}></span>
      </div>
      {agentsChats?.length > 0 ? agentsChats.slice(0, 2).map((agent, index) => (
        <ChatItem key={index} agent={agent} handleSelectCard={handleSelectCard} />
      )) : null}
    </div>
  );
};


const ChatItem = ({ agent, t, handleSelectCard }) => {
  return (
    <div className={style.contactItem} onClick={() => handleSelectCard(agent, agent?.type || "agent")}>
      <div className={style.contactAvatar}>
        <IconImage />
      </div>
      <div className={style.contactInfo}>
        <div className={style.contactName}>{agent?.name || agent?.agent}</div>
        <div className={style.contactStats}>
          {agent?.type === 'chat' ? <span>{`Chat del agente: ${agent?.agent}`}</span> :
            <span>{`Agente`}</span>}
        </div>
      </div>
      <div className={style?.contactAmount}>
      </div>
    </div>
  );
};

const LeftPanel = ( {incomeRef,
      documentsRef,
      contactsRef,
      assetsRef,
      contenedorRef,
      teamRef}) => {
  const { user } = useSelector((state) => state.user);
  const { contacts, totalContacts } = useSelector((state) => state.contacts);
  const { assets, totalAssets: totalAssetsSlice } = useSelector((state) => state.assets);
  const [activeTab, setActiveTab] = useState('transactions');
  const [searchQuery, setSearchQuery] = useState('');
  const [limit, setLimit] = useState(2);
  const [page, setPage] = useState(0);
  const [totalPagination, setTotalPagination] = useState()
  const [tabEffect, setTabEffect] = useState('document')

  const {
    agents,
    loading: loadingAgent,
    error,
    selectedAgentSlice,
  } = useSelector((state) => state.agents);

  const { chatList, searchTerm: searchTermState } = useSelector(
    (state) => state.chat
  );

  const location = useLocation();
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useTranslation(["dashboard", "Preview"]);


//   useEffect(() => {
//   console.log("incomeRef:", incomeRef?.current);
//   console.log("documentsRef:", documentsRef?.current);
//   console.log("contactsRef:", contactsRef?.current);
//   console.log("assetsRef:", assetsRef?.current);
//   console.log("teamRef:", teamRef?.current);
// }, []);


  const handleVisible = (nombre) => {
    // console.log(`${nombre} llegó al tope (con margen)`);
    // // Llamá a tu función acá
    setTabEffect(nombre)
  };

useEffect(() => {
    if (!contenedorRef?.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // console.log("Elemento visible:", entry.target);
            const nombre = entry.target.getAttribute("name");
            handleVisible(nombre);
          }
        });
      },
      {
        root: contenedorRef.current,
        rootMargin: "-20px 0px 0px 0px",
        threshold: 0.1,
      }
    );

    [incomeRef, documentsRef, contactsRef, assetsRef, teamRef].forEach((ref) => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => {
      [incomeRef, documentsRef, contactsRef, assetsRef, teamRef].forEach((ref) => {
        if (ref.current) observer.unobserve(ref.current);
      });
    };
  }, [contenedorRef]);

   const [selectedOption, setSelectedOption] = useState({
    "Orden Alfabético": "A-Z",
    Estado: "Todos",
    "Moneda Preferida": "USD",
    "# Transacciones": "Mayor a menos",
    "Ingresos/Costes": "Ingresos de mayor a menor",
  });

  const options = [
    {
      name: "Orden Alfabético",
      label: t("alphabeticOrder"),
      subOptions: [
        { display: "A-Z", value: "A-Z" },
        { display: "Z-A", value: "Z-A" },
      ],
    },
    {
      name: "Estado",
      label: t("status"),
      subOptions: [
        { display: t("all"), value: "Todos" },
        { display: t("approved"), value: "Aprobados" },
        { display: t("notApproved"), value: "No aprobados" },
        { display: t("paid"), value: "Pagados" },
        { display: t("pending"), value: "Pendiente" },
        { display: t("defaulted"), value: "Incumplidos" },
        { display: t("expired"), value: "Vencido" },
        { display: t("cancelled"), value: "Anulados" },
      ],
    },
    {
      name: "Moneda Preferida",
      label: t("preferredCurrency"),
      subOptions: "currencies",
    },
    {
      name: "# Transacciones",
      label: t("transactions"),
      subOptions: [
        { display: t("higherToLower"), value: "Mayor a menos" },
        { display: t("lowerToHigher"), value: "Menor a mayor" },
      ],
    },
    {
      name: "Ingresos/Costes",
      label: t("incomeCosts"),
      subOptions: [
        {
          display: t("incomeHigherToLower"),
          value: "Ingresos de mayor a menor",
        },
        {
          display: t("incomeLowerToHigher"),
          value: "Ingresos de menor a mayor",
        },
        { display: t("costsHigherToLower"), value: "Costes de mayor a menor" },
        { display: t("costsLowerToHigher"), value: "Costes de menor a mayor" },
      ],
    },
    {
      name: "dateFilter",
      label: t("dateFilter"),
      subOptions: [
        { display: t('1month'), value: "1month" },
        { display: t('3month'), value: "3month" },
        { display: t('6month'), value: "6month" },
        { display: t('1year'), value: "1year" },

      ],
    },
    {
      name: "dateOrder",
      label: t("dateOrder"),
      subOptions: [
        { display: t('ascendant'), value: "ascendant" },
        { display: t('falling'), value: "falling" },
      ],
    },
  ];

  const handleSelectCard = (team, type) => {
    if (type === 'asset') {
      // sessionStorage.setItem("internalNavigation", "true");
      dispatch(setFatherNewAsset('home'))
      dispatch(setAsset(team));
      dispatch(setTab(t('assets')))
      navigate(`/admin/assets/${team._id}`, { state: { backgroundLocation: location } })

    } else if (type === 'contact') {
      // sessionStorage.setItem("internalNavigation", "true");
      dispatch(setContact(team));
      dispatch(setTab(t('contacts')))
      dispatch(setFatherNewContact('home'))
      navigate(`/admin/contacts/${team._id}`, { state: { backgroundLocation: location } })
    } else if (type === "agent") {
      navigate(`/admin/chat/${team._id}`)
    } else if (type === "chat") {
      const agentId = agents.agents.filter(agent => agent.name === team.agent)[0]._id
      navigate(`/admin/chat/${agentId}/${team.id}`)
    }
  };


  useEffect(() => {
    dispatch(fetchByMenu({ query: searchQuery }));
    dispatch(getAgents({ search: searchQuery }))
  }, [user, searchQuery]);

  const [resultAssets, setResultAssets] = useState("")

    useEffect(() => {
    const fn = async () => {
      const result = await dispatch(getAllAssets({
        search: searchQuery,
        limit,
        skip: page * limit,
        sortAlpha: selectedOption["Orden Alfabético"],
        statusFilter: selectedOption.Estado,
        sortDate: selectedOption.dateFilter,
        sortQuantity: selectedOption.Generado,
        dateOrder: selectedOption.dateOrder
      }));
      setResultAssets(result.payload)
    }
    fn()
  }, [searchQuery, limit, page, selectedOption])

    const [resultContacts, setResultContacts] = useState({})

  useEffect(() => {
    const fn = async () => {
      const result = await dispatch(
        getAllContacts({
          search: searchQuery,
          limit,
          skip: page * limit,
          sortAlpha: selectedOption["Orden Alfabético"],
          statusFilter: selectedOption.Estado,
          sortDate: selectedOption.dateFilter,
          sortQuantity: selectedOption.Generado,
          dateOrder: selectedOption.dateOrder
        })
      );
      setResultContacts(result.payload)
    }
    fn()

  }, [searchQuery, limit, page, selectedOption])

  const filteredContacts = useMemo(() => {
    return contacts || [];
  }, [contacts]);

  const filteredAssets = useMemo(() => {
    return assets || [];
  }, [assets]);

  const agentsChats = useMemo(() => {
    const filteredAgents = agents?.agents || [];
    const filteredChats = chatList || [];

    return [
      ...filteredAgents.map(agent => ({ ...agent, type: 'agent' })).slice(0, 1),
      ...filteredChats.map(chat => ({ ...chat, type: 'chat' })).slice(0, 1)
    ];
  }, [agents, chatList]);


  const filteredDocuments = useMemo(() => {
    if (searchQuery.length === 0) {
      return [
        {
          id: 'T001',
          status: 'Aprobado',
          statusColor: 'approved',
          pendingStatus: 'Pendiente',
          dueDate: '25 Dic 2025',
          type: 'folder',
          category: 'Gastos Operativos',
          time: 'Hace una hora',
          amount: '0,00€',
          isOverdue: false,
          title:"Facturas",
          separation:"bar",
          username:"username",
          capacity:"32GB",
          date:"date",
          
        },
        {
          id: 'T002',
          status: 'Aprobado',
          statusColor: 'approved',
          pendingStatus: 'Pendiente',
          dueDate: '25 Dic 2025',
          type: 'folder',
          category: 'Gastos Operativos',
          time: 'Hace una hora',
          amount: '0,00€',
          isOverdue: true,
          title:"Recibos",
          separation:"point",
          username:"username",
          date:"date",
          capacity:"32GB",
        },
         {
          id: 'T003',
          status: 'Aprobado',
          statusColor: 'fail',
          pendingStatus: 'Pendiente',
          dueDate: '25 Dic 2025',
          type: 'Factura',
          time: 'Hace una hora',
          amount: '0,00€',
          isOverdue: false,
          username:"username",
           capacity:"32GB",
          date:"date",
          separation:"bar",
          termination:".txt",
          concept:"Concepto",
          category:"Categoría"
          
        },
        {
          id: 'T004',
          status: 'Aprobado',
          statusColor: 'pending',
          pendingStatus: 'Pendiente',
          dueDate: '25 Dic 2025',
          type: 'Presupuesto',
          concept: 'Gastos Operativos',
          time: 'Hace una hora',
          amount: '0,00€',
          isOverdue: true,
          username:"username",
           capacity:"32GB",
          date:"date",
          separation:"point",
          termination:".jpg",
          category:"Factura",
        },
        {
          id: 'T005',
          status: 'Aprobado',
          statusColor: 'defeated',
          pendingStatus: 'Pendiente',
          dueDate: '25 Dic 2025',
          type: 'Presupuesto',
          concept: 'Gastos Operativos',
          time: 'Hace una hora',
          amount: '0,00€',
          isOverdue: true,
          username:"username",
           capacity:"32GB",
          date:"date",
          separation:"bar",
          termination:".pdf",
          category:"Factura",
        },
         {
          id: 'T006',
          status: 'Aprobado',
          statusColor: 'paid',
          pendingStatus: 'Pendiente',
          dueDate: '25 Dic 2025',
          type: 'Presupuesto',
          concept: 'Gastos Operativos',
          time: 'Hace una hora',
          amount: '0,00€',
          isOverdue: true,
          username:"username",
           capacity:"32GB",
          date:"date",
          separation:"bar",
          termination:".pdf",
          category:"Factura",
        },
         {
          id: 'T007',
          status: 'Aprobado',
          statusColor: 'canceled',
          pendingStatus: 'Pendiente',
          dueDate: '25 Dic 2025',
          type: 'Presupuesto',
          concept: 'Gastos Operativos',
          time: 'Hace una hora',
          amount: '0,00€',
          isOverdue: true,
          username:"username",
           capacity:"32GB",
          date:"date",
          separation:"bar",
          termination:".pdf",
          category:"Factura",
        },
         {
          id: 'T008',
          status: 'Aprobado',
          statusColor: 'draft',
          pendingStatus: 'Pendiente',
          dueDate: '25 Dic 2025',
          type: 'Presupuesto',
          concept: 'Gastos Operativos',
          time: 'Hace una hora',
          amount: '0,00€',
          isOverdue: true,
          username:"username",
           capacity:"32GB",
          date:"date",
          separation:"bar",
          termination:".pdf",
          category:"Factura",
        },
      ];
    } else {
      return [];
    }
  }, [searchQuery]);

    const filteredTeam = useMemo(() => {
    if (searchQuery.length === 0) {
      return [
        {
          id: 'T001',
          status: 'Aprobado',
          my:true
          
        },
        {
          id: 'T002',
          status: 'Aprobado',
          statusColor: 'green',
          email: 'example@email.com',

        },
         {
          id: 'T003',
          status: 'Aprobado',
          statusColor: 'grey',
          email: 'example@email.com'          
        },
        {
          id: 'T004',
          status: 'pending',
          email: 'example@email.com',
        },
      ];
    } else {
      return [];
    }
  }, [searchQuery]);


  const filteredIncomes = useMemo(() => {
    if (searchQuery.length === 0) {
      return [
        {
          title: t('exceptionalExpenses'),
          amount: "0,00€",
          percentage: "0%",
          subCategory: "expense",
          type: "pay",
          category: "expense"
        },
        {
          title: t('otherLosses'),
          amount: "0,00€",
          percentage: "0%",
          subCategory: "other_management_losses",
          type: "pay",
          category: "expense"
        },
        {
          title: t('socialSecurity'),
          amount: "0,00€",
          percentage: "0%",
          subCategory: "company_social_security",
          type: "pay",
          category: "expense"
        },
        {
          title: t('compensations'),
          amount: "0,00€",
          percentage: "0%",
          subCategory: "compensations",
          type: "pay",
          category: "expense"
        },
        {
          title: t('salareisAndWages'),
          amount: "0,00€",
          percentage: "0%",
          subCategory: "wages_and_salaries",
          type: "pay",
          category: "expense"
        },
        {
          title: t('otherServices'),
          amount: "0,00€",
          percentage: "0%",
          subCategory: "other_services",
          type: "pay",
          category: "expense"
        },
        {
          title: t('supplies'),
          amount: "0,00€",
          percentage: "0%",
          subCategory: "utilities",
          type: "pay",
          category: "expense"
        },
        {
          title: t('publicRelations'),
          amount: "0,00€",
          percentage: "0%",
          subCategory: "advertising_and_pr",
          type: "pay",
          category: "expense"
        },
        {
          title: t('bankingAndSimilarServices'),
          amount: "0,00€",
          percentage: "0%",
          subCategory: "banking_services",
          type: "pay",
          category: "expense"
        },
        {
          title: t('insurancePremiums'),
          amount: "0,00€",
          percentage: "0%",
          subCategory: "insurance",
          type: "pay",
          category: "expense"
        },
        // {
        //   title: t('productSales'),
        //   amount: "0,00€",
        //   percentage: "0%",
        //   subCategory: "product_sales",
        //   type: "pay",
        //   category: "expense"
        // },
        // {
        //   title: t('incomeFromServices'),
        //   amount: "0,00€",
        //   percentage: "0%",
        //   subCategory: "service_income",
        //   type: "pay",
        //   category: "expense"
        // },
        // {
        //   title: t('bankInterest'),
        //   amount: "0,00€",
        //   percentage: "0%",
        //   subCategory: "bank_interest",
        //   type: "pay",
        //   category: "expense"
        // },
      ];
    } else {
      return [];
    }
  }, [searchQuery, t]);

  const getTabsWithData = () => {
    const tabsWithData = [];

    if (filteredDocuments.length > 0) {
      tabsWithData.push({
        title: t('documents'),
        value: 'documents'
      });
    }

    if (filteredIncomes.length > 0) {
      tabsWithData.push({
        title: t('incomeAndExpenses'),
        value: 'income'
      });
    }

    if (filteredDocuments.length > 0) {
      tabsWithData.push({
        title: 'Transacciones',
        value: 'transactions'
      });
    }

    if (filteredContacts.length > 0) {
      tabsWithData.push({
        title: 'Contactos',
        value: 'contacts'
      });
    }

    if (filteredAssets.length > 0) {
      tabsWithData.push({
        title: 'Activos',
        value: 'assets'
      });
    }

    // if (agentsChats.length > 0) {
    //     tabsWithData.push({
    //         title: 'Chats',
    //         value: 'chat'
    //     });
    if (agentsChats.length > 0) {
      tabsWithData.push({
        title: t('team'),
        value: 'team'
      });
    }

    return tabsWithData;
  };

  const tabs = getTabsWithData();


  useEffect(() => {
    if (tabs.length > 0 && !tabs.find(tab => tab.value === activeTab)) {
      setActiveTab(tabs[0].value);
    }
    if(activeTab == "contacts") setTotalPagination(resultContacts.total)
    else if(activeTab == "assets") setTotalPagination(resultAssets.total)
  }, [tabs, activeTab]);

  // console.log('esto es activetab', activeTab)
  // console.log('esto es filteredDocuments', filteredDocuments)


  const getOrderedSections = () => {
    const sections = [

      { id: 'income', component: <IncomeSection incomes={filteredIncomes} t={t} incomeRef={incomeRef} />, hasData: filteredIncomes.length > 0 },
      { id: 'documents', component: <DocumentsSection documents={filteredDocuments} t={t} documentsRef={documentsRef}/>, hasData: filteredDocuments.length > 0 },

      {
        id: 'contacts', component: <ContactsSection  contactsRef={contactsRef}
          contacts={filteredContacts} t={t} handleSelectCard={handleSelectCard} result={resultContacts} />, hasData: filteredContacts.length > 0 
      },
      {
        id: 'assets', component: <AssetsSection assetsRef={assetsRef}
         result={resultAssets}
          assets={filteredAssets} t={t} handleSelectCard={handleSelectCard} /> , hasData: filteredAssets.length > 0 
      },
       { id: 'team', component: <TeamSection t={t} handleSelectCard={handleSelectCard} teams={filteredTeam} teamRef={teamRef} />, hasData: filteredTeam.length > 0 },
      // { id: 'chat', component: <ChatSection t={t} handleSelectCard={handleSelectCard} agentsChats={agentsChats} />, hasData: agentsChats.length > 0 }
    ];


    const sectionsWithData = sections.filter(section => section.hasData);


    if (sectionsWithData.length === 0) {
      return [];
    }


    const activeIndex = sectionsWithData.findIndex(section => section.id === activeTab);


    if (activeIndex === -1) {
      return sectionsWithData.map(section => section.component);
    }


    const reorderedSections = [
      sectionsWithData[activeIndex],
      ...sectionsWithData.slice(0, activeIndex),
      ...sectionsWithData.slice(activeIndex + 1)
    ];

    return reorderedSections.map(section => section.component);
  };


  const hasAnyData = () => {

    const hasIncomeData = filteredIncomes.length > 0;

    const hasDocumentData = filteredDocuments.length > 0;

    const hasContactData = filteredContacts.length > 0;

    const hasAssetData = filteredAssets.length > 0;

    const hasChatData = agentsChats.length > 0;


    return hasIncomeData || hasDocumentData || hasContactData || hasAssetData || hasChatData;
  };


  

  return (
    <div className={style.LeftPanelContainer}>
      <div className={style.leftPanel}>

         <div className={style.sectionHeaderContainer}>
        <NavigationTabs tabEffect={tabEffect} tabs={tabs} activeTab={activeTab} onTabChange={(value) => {setActiveTab(value)
        setTabEffect(value)
        }} totalPagination={totalPagination || 0}
          limit={limit} setLimit={setLimit} page={page} setPage={setPage} />
        <div className={style.searchContainer}>
          <SearchBar searchQuery={searchQuery} onSearchChange={setSearchQuery} options={options} selectedOption={selectedOption} setSelectedOption={setSelectedOption} />
        </div>
      </div>
        {/* <div>
                <NavigationTabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} totalPagination={totalPagination[activeTab]}
                limit={limit} setLimit={setLimit} page={page} setPage={setPage}    />
                <div className={style.searchContainer}>
                <SearchBar searchQuery={searchQuery} onSearchChange={setSearchQuery} />
                </div>
                </div> */}

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
        //  ref={contenedorRef}
         >
          {getOrderedSections()}
        </div>
      </div>
      <ActionButtons />

      {!hasAnyData() && (
        // <div className={style.messageDafault}>
        //   <NoData />
        //   <p className={style.titleMessage}>{t('noDataInTheSelectedRange')}</p>
        //   <p className={style.descriptionMessage} >{t('NoResultsHaveBeenFoundWithTheseSpecifications')}</p>
        // </div>
        <div className={style.documentsDontFound}>
        <DocumentsDontFound/>
        <span>{t('NoResultsHaveBeenFoundWithTheseSpecifications')}</span>
        </div>
      )}

    </div>
  );
};

export default LeftPanel;